export type CloudSyncEventStatus = 'saving' | 'saved' | 'error';

export type CloudSyncEventDetail = {
  status: CloudSyncEventStatus;
  /** Optional human-readable source e.g. 'sma_surveillance_imports' */
  source?: string;
  /** ISO timestamp when status was emitted */
  at: string;
  /** Optional error message */
  message?: string;
};

const EVENT_NAME = 'gaintracker:cloud-sync';

export function emitCloudSync(detail: Omit<CloudSyncEventDetail, 'at'> & { at?: string }) {
  if (typeof window === 'undefined') return;
  const payload: CloudSyncEventDetail = {
    at: detail.at ?? new Date().toISOString(),
    status: detail.status,
    source: detail.source,
    message: detail.message,
  };
  window.dispatchEvent(new CustomEvent<CloudSyncEventDetail>(EVENT_NAME, { detail: payload }));
}

export function onCloudSync(handler: (detail: CloudSyncEventDetail) => void) {
  if (typeof window === 'undefined') return () => {};
  const listener = (ev: Event) => {
    const custom = ev as CustomEvent<CloudSyncEventDetail>;
    if (!custom.detail) return;
    handler(custom.detail);
  };
  window.addEventListener(EVENT_NAME, listener);
  return () => window.removeEventListener(EVENT_NAME, listener);
}
